<!-- <div class="datetime-picker-with-timezone" style="position: relative;">
    <p-calendar #calendar [panelStyle]="{'width': '250px'}" panelStyleClass="custom-calendar" size="small"
        name="calendar" inputId="calendar-12h" [ngModel]="datetime12h" [showTime]="true" hourFormat="12"
        [showIcon]="true" appendTo="body" (onSelect)="onDateTimeSelect(group, field, $event)" [showSeconds]="false"
        styleClass="compact-calendar">
        <ng-template pTemplate="footer">
            <label style="font-size: 12px;">Timezone </label>
            <p-dropdown styleClass="custom-dropdown-tz" autoWidth="false" [style]="{'width': '100%', 'height': '30px'}"
                size="small" name="tzone" [options]="timezones" [(ngModel)]="selectedTimezone"
                [ngModelOptions]="{standalone: true}" placeholder="Select Timezone" optionLabel="label"
                optionValue="value" (onChange)="onTimezoneChange(group, field, $event)"></p-dropdown>
        </ng-template>
    </p-calendar>
    <label class="date-display">{{selectedDateWithTimeZone}}</label>
</div> -->

<div class="datetime-picker-with-timezone" style="position: relative;">
    <p-calendar 
      #calendar
      [panelStyle]="{'width': '250px'}" 
      panelStyleClass="custom-calendar"
      size="small"
      name="calendar"
      inputId="calendar-12h" 
      [(ngModel)]="selectedDate" 
      [showTime]="showTime" 
      hourFormat="hourFormat"
      [showIcon]="true"
      [appendTo]="'body'"
      (onSelect)="onDateTimeSelect($event)"
      [showSeconds]="false"
      [timeOnly]="false"
      [stepHour]="1"
      [stepMinute]="1"
      [readonlyInput]="true"
      [inputStyle]="{width: parentWidth}"
      [disabled]="disabled"
    >
      <ng-template pTemplate="footer">
        <div class="p-fluid">
          <label>Timezone</label>
          <p-dropdown 
            [options]="timezones"
            [(ngModel)]="selectedTimezone"
            [ngModelOptions]="{standalone: true}"
            placeholder="Select Timezone"
            optionLabel="label"
            optionValue="value"
            (onChange)="onTimezoneChange($event)"
            [style]="{'width': '100%', 'margin-top': '0.5rem'}"
          ></p-dropdown>
        </div>
      </ng-template>
    </p-calendar>
    <label class="date-display">{{selectedDateWithTimeZone}}</label>
</div>